// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/rich_text.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_text_format } from "./text_format_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/rich_text.proto.
 */
export const file_studyo_today_planners_v1_resources_rich_text = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3JpY2hfdGV4dC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJYCghSaWNoVGV4dBIMCgR0ZXh0GAEgASgJEj4KBmZvcm1hdBgCIAEoDjIuLnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuVGV4dEZvcm1hdEIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_planners_v1_resources_text_format]);

/**
 * Describes the message studyo.today.planners.v1.resources.RichText.
 * Use `create(RichTextSchema)` to create a new message.
 */
export const RichTextSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_rich_text, 0);

